import { createBrowserHistory } from "history";
const history: any = createBrowserHistory();

export default history;